import { useEffect, useState } from 'react'

export type ZendeskWidgetOptions = {
  name?: string | null
  email?: string | null
  phone?: string | null
  language: string
}

export const updateOpts = (options?: ZendeskWidgetOptions) => {
  const chat = window.$zopim?.livechat
  if (!chat || !options) return
  options.language && chat.setLanguage(options.language)
  options.email && chat.setEmail(options.email)
  options.phone && chat.setPhone(options.phone)
  options.name && chat.setName(options.name)
}
export const useZendeskWidget = (key?: string, options?: ZendeskWidgetOptions) => {
  const [isZendeskMounted, setIsZendeskMounted] = useState(typeof window === 'undefined' ? false : !!window?.$zopim)

  useEffect(() => {
    if (!isZendeskMounted || !options) return
    updateOpts(options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options?.email, options?.phone, options?.name, options?.language])

  useEffect(() => {
    if (!options) return
    if (!isZendeskMounted) {
      const interval = setInterval(() => {
        const current = typeof window === 'undefined' ? false : !!window?.$zopim
        if (current) {
          setIsZendeskMounted(current)
          clearInterval(interval)
        }
      }, 100)

      return () => {
        clearInterval(interval)
      }
    }
    window.$zopim?.(() => {
      updateOpts(options)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isZendeskMounted])

  useEffect(() => {
    if (typeof window === 'undefined' || !key) return
    const script = document.createElement('script')
    script.id = 'ze-snippet'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`
    document.head.insertBefore(script, document.head.childNodes[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
}
